import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        // box-border: stable layout with border-2; no focus scale (see index.css) so rings stay even.
        "box-border flex min-h-[80px] w-full resize-y rounded-lg border-2 border-gray-200 bg-white px-4 py-3 font-jakarta text-base transition-[border-color,box-shadow] duration-200 placeholder:text-gray-400",
        "hover:border-gray-300 hover:shadow-sm",
        "focus:outline-none focus-visible:outline-none focus-visible:border-[#166B93] focus-visible:shadow-[0_0_0_3px_rgba(22,107,147,0.14)]",
        "disabled:cursor-not-allowed disabled:bg-gray-50 disabled:opacity-50",
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
Textarea.displayName = "Textarea"

export { Textarea }
